export const buildColumnDisplayValueComparator =
  <TColumn extends { id: string }>(getDisplayValueForColumn: (columnId: string) => string) =>
  (columnA: TColumn, columnB: TColumn): number =>
    getDisplayValueForColumn(columnA.id)
      .toLocaleLowerCase()
      .localeCompare(getDisplayValueForColumn(columnB.id).toLocaleLowerCase());
